import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, transform: "translate(2 2)" }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M10 10 10 6.429" }), /* @__PURE__ */ React.createElement("path", { d: "M10 10 14.464 14.465" })));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
